import React, { useEffect, useState } from 'react';
// import { reactPlugin } from '../../../appInsights';
// import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { jsonEditorStyles } from '../jsonEditorStyles';
import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import jsonComponentsConfig from '../../../constants/jsonComponents';
import useComponentUIHook from './useComponentUIHook';
import { TextComponent } from '../../uiComponents';
import SessionManagement, { sessionFieldsAreValid } from './sessionManagement';
import { cloneDeep } from 'lodash';

interface componentProps {
  componentData: any;
  closeGritComponent: any;
  setUnsavedChanges: any;
}
const GenerateValidateMagicLink = ({ componentData, closeGritComponent, setUnsavedChanges }: componentProps) => {
  const {
    modifiedData,
    setModifiedData,
    checkIfSameIgnoringSubFlows: checkIfSameIgnoringSubFlows,
    allClaims,
  } = useComponentUIHook(componentData);
  const classes = jsonEditorStyles();
  const configData = jsonComponentsConfig.validateMagicLink;
  const [disableSubmit, setDisableSubmit] = useState<boolean>(false);

  useEffect(() => {
    const _res: boolean = checkIfSameIgnoringSubFlows();
    setDisableSubmit(_res || (!sessionFieldsAreValid(modifiedData)));
    setUnsavedChanges(_res);
  }, [modifiedData]);

  return (
    <>
      <FormControl required sx={{ m: 1, minWidth: 400 }}>
        <TextComponent
          changeHandler={(e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
            setModifiedData({ ...modifiedData, email: e.target.value });
          }}
          data={{
            value: modifiedData['email'],
            label: 'Email',
          }}
        />

        {configData.sessionManagement && (
          <SessionManagement
            modifiedData={modifiedData}
            changeHandler={(data: any) => setModifiedData(data)}
            sessionTypes={configData.sessionTypes}
          />
        )}

        <Button
          type="submit"
          fullWidth
          variant="contained"
          disabled={disableSubmit}
          sx={{ mt: 3, mb: 2 }}
          onClick={() => {
            closeGritComponent(cloneDeep(modifiedData));
          }}
        >
          Save
        </Button>
      </FormControl>
    </>
  );
};
// export default withAITracking(reactPlugin, GenerateValidateMagicLink);
export default GenerateValidateMagicLink;
